import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker,  Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import '../pages/map.css';
import  MarkerIcon from '../../src/assets/images/icons/map-marker.svg';
 

// Custom icon for markers
const customIcon = new L.Icon({
  iconUrl: MarkerIcon,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const CustomMap = () => {
  const [hoveredAddress, setHoveredAddress] = useState('');

  // Sample data
  const markers = [
    { id: 1, position: [19.076, 72.8777], address: 'Mumbai, India' },
    { id: 2, position: [40.760375, -73.973217], address: 'New York<br/>  535 Madison Avenue,<br/> 12th Floor New York,<br/>NY 10022,<br/><br/> Tel: 212.355.0755 ' },
    { id: 3, position: [13.0827, 80.2707], address: 'Chennai, India' },
  ];

  return (
    <div style={{ position: 'relative', height: '100vh', width: '100%' }}>
      {/* Hovered Address Display */}
      {hoveredAddress && (
        <div
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            background: '#000',
            padding: '10px',
            borderRadius: '5px',
            boxShadow: '0 0 10px rgba(0,0,0,0.2)',
          }}
        >
          <strong>Address:</strong> {hoveredAddress}
        </div>
      )}

      {/* Map */}
      <MapContainer center={[20.5937, 78.9629]} zoom={3} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          
        />

        {/* Markers */}
        {markers.map((marker) => (
          <Marker
            key={marker.id}
            position={marker.position}
            icon={customIcon}
            eventHandlers={{
              mouseover: () => setHoveredAddress(marker.address),
              mouseout: () => setHoveredAddress(''),
            }}
          >
            <Tooltip className="custom-tooltip" direction="top" offset={[0, -10]}><div
              dangerouslySetInnerHTML={{
                __html: marker.address,
              }}
            /></Tooltip>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default CustomMap;
